import "./Footer.css";
import {
  FaEnvelope,
  FaPhone,
  FaWhatsapp,
  FaLandmark,
  FaInstagram,
  FaFacebook,
  FaUserLock,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-content">
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-text">
                <span>
                  <FaPhone
                    className="contact-icon"
                    style={{ transform: "scaleX(-1)" }}
                  />
                </span>{" "}
                <span>
                  <a href="tel:+919500944656" className="contact-icon">
                    +91 9500944656
                  </a>
                </span>
              </span>
            </div>
            {/* <div className="contact-item">
              <span className="contact-text">
                <span>
                  <FaWhatsapp className="contact-icon" />
                </span>
                <span><a href="https://wa.me/918248588257" target="_blank" className="contact-icon" >+91 82485 88257</a></span>
              </span>
            </div> */}
            <div className="contact-item">
              <span className="contact-text">
                <a
                  href="https://www.instagram.com/bear_bitz/"
                  target="_blank"
                  className="contact-icon"
                >
                  <FaInstagram /> Bearbitz
                </a>
              </span>
            </div>
            <div className="contact-item">
              <span className="contact-text">
                <a
                  href="https://www.facebook.com/profile.php?id=61579309993904"
                  target="_blank"
                  className="contact-icon"
                >
                  <FaFacebook /> Bearbitz
                </a>
              </span>
            </div>
            <div className="contact-item">
              <span className="contact-text">
                <a
                  href="/privacy-policy"
                  target="_blank"
                  className="contact-icon"
                >
                  <FaUserLock /> Privacy Policy
                </a>
              </span>
            </div>
            <div className="contact-item">
              <span className="contact-text">
                <span>
                  <FaLandmark className="contact-icon" />
                </span>
                <span>
                  Tamilnadu, India.
                  {/* 1/2, Ramasamy Gounder Layout, 60 Feet Road, Perichipalayam
                  South, Tirupur - 641 604. */}
                </span>
              </span>
            </div>
            <div className="contact-item">
              <span className="contact-text">
                <span>
                  <FaEnvelope className="contact-icon" />
                </span>
                <span>sales@www.bearbitz.in</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
